import gql from 'graphql-tag';

const PENDING_STOCK_MUTATION_FRAGMENT = gql`
	fragment pendingStockMutationItem on PendingStock {
		id
		quantity
		status
		expiryDate
		batchExpiryDates
		resolvedAt
		warehouse {
			id
			name
		}
		product {
			id
			name
		}
	}
`;

export const CREATE_MANUAL_PENDING_STOCK = gql`
	mutation (
		$warehouseProductId: ID!,
		$quantity: Int!,
		$reasonType: Int,
		$note: String,
		$expiryDate: Date,
		$batchExpiryDates: JSON,
	) {
		createManualPendingStock(
			warehouseProductId: $warehouseProductId,
			quantity: $quantity,
			reasonType: $reasonType,
			note: $note,
			expiryDate: $expiryDate,
			batchExpiryDates: $batchExpiryDates,
		) {
			...pendingStockMutationItem
		}
	}
	${PENDING_STOCK_MUTATION_FRAGMENT}
`;

export const CREATE_RETURNED_PENDING_STOCK_FROM_PRODUCT = gql`
	mutation (
		$warehouseId: ID!,
		$productId: ID!,
		$serviceRunId: ID,
		$quantity: Int!,
		$note: String,
		$expiryDate: Date,
		$batchExpiryDates: JSON,
		$operationId: String,
	) {
		createReturnedPendingStockFromProduct(
			warehouseId: $warehouseId,
			productId: $productId,
			serviceRunId: $serviceRunId,
			quantity: $quantity,
			note: $note,
			expiryDate: $expiryDate,
			batchExpiryDates: $batchExpiryDates,
			operationId: $operationId,
		) {
			...pendingStockMutationItem
		}
	}
	${PENDING_STOCK_MUTATION_FRAGMENT}
`;

export const MOVE_PENDING_STOCK_TO_WAREHOUSE = gql`
	mutation (
		$id: ID!,
		$quantity: Int,
		$expiryDate: Date,
		$batchExpiryDates: JSON,
	) {
		movePendingStockToWarehouse(
			id: $id,
			quantity: $quantity,
			expiryDate: $expiryDate,
			batchExpiryDates: $batchExpiryDates,
		) {
			...pendingStockMutationItem
		}
	}
	${PENDING_STOCK_MUTATION_FRAGMENT}
`;

export const DISCARD_PENDING_STOCK = gql`
	mutation (
		$id: ID!,
		$quantity: Int,
		$batchExpiryDates: JSON,
	) {
		discardPendingStock(
			id: $id,
			quantity: $quantity,
			batchExpiryDates: $batchExpiryDates,
		) {
			...pendingStockMutationItem
		}
	}
	${PENDING_STOCK_MUTATION_FRAGMENT}
`;
